import React from 'react';

import setActiveTopMenuDropdownOperation from 'editor/src/store/app/operation/setActiveTopMenuDropdownOperation';
import isTopMenuDropdownVisible from 'editor/src/store/app/selector/isTopMenuDropdownVisible';
import { TopMenuDropdown } from 'editor/src/store/app/types';
import setSidebarActiveTabByNameOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabByNameOperation';
import setSidebarActiveTabOperation from 'editor/src/store/editorModules/sidebar/operation/setSidebarActiveTabOperation';
import isSidebarTabActive from 'editor/src/store/editorModules/sidebar/selector/isSidebarTabActive';
import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import { MenuItemProps } from 'editor/src/component/Menu/type';
import MenuButton from 'editor/src/component/TopMenuDesktop/buttons/MenuButton';

import IconTextFitting from '../../../Icon/IconTextFitting';

type Props = Pick<MenuItemProps, 'mode' | 'isMobile' | 'close'>;

function ButtonTextFitting({ mode, isMobile, close }: Props) {
  const isActive = useSelector((state) =>
    isMobile
      ? isSidebarTabActive(state, TAB_NAMES.TEXT_FITTING)
      : isTopMenuDropdownVisible(state, TopMenuDropdown.TextFitting),
  );
  const dispatch = useDispatch();

  const handleClick = () => {
    if (isMobile) {
      if (isActive) {
        dispatch(setSidebarActiveTabOperation(-1));
      } else {
        dispatch(setSidebarActiveTabByNameOperation(TAB_NAMES.TEXT_FITTING));
      }
    } else {
      dispatch(setActiveTopMenuDropdownOperation(TopMenuDropdown.TextFitting));
      close?.();
    }
  };

  return (
    <MenuButton
      Icon={IconTextFitting}
      on={isActive}
      mode={mode}
      handleClick={handleClick}
      i18nKey="editor-text-wrapping"
      className="cy-button-text-fitting"
      showTooltip={false}
    />
  );
}

export default React.memo(ButtonTextFitting);
